import { GAME_HISTORY_BASE } from "../services/mindshareData";
export { SNAPSHOT_URL, HISTORY_URL, GAME_HISTORY_BASE, GAME_HISTORY_MANIFEST_URL } from "../services/mindshareData";
export const DATA_BUCKET = "mindgamedataapi";
export const MOMENTUM_URL = `${GAME_HISTORY_BASE}/mindSHARE_Momentum_2026-09-20.csv`;
export const BUSINESS_ROLLUPS_BASE_URL = "https://d1ct3zodbaiefe.cloudfront.net/mindshare_rollups/";
